(() => {
  const initJukebox = (component) => {
    if (component.dataset.jukeboxReady === 'true') return;
    component.dataset.jukeboxReady = 'true';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let cleanupTimer;
    const animateSlide = (slide, page) => {
      if (!slide || reduceMotion.matches) return;
      clearTimeout(cleanupTimer);
      component.style.setProperty('--moto-jukebox-x', page % 2 === 0 ? '62%' : '38%');
      component.classList.remove('is-jukebox-changing');
      slide.classList.remove('is-jukebox-entering');
      void component.offsetWidth;
      component.classList.add('is-jukebox-changing');
      slide.classList.add('is-jukebox-entering');
      cleanupTimer = setTimeout(() => {
        component.classList.remove('is-jukebox-changing');
        slide.classList.remove('is-jukebox-entering');
      }, 950);
    };
    component.addEventListener('slideChanged', (event) => animateSlide(event.detail.currentElement, event.detail.currentPage));
  };
  const initAll = () => document.querySelectorAll('.es-home slideshow-component').forEach(initJukebox);
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
